<?php

\Core\View::$template = function() {
    $html = '' ;
    return $html ;

} ;


// WEBPACK FOOTER //
// app/Logout/View/Logout.php